export const STRUCTURE_CATEGORIES = {
  core: 'structureCategories.core',
  iterator: 'structureCategories.iterator',
} as const;
